import { styled } from "@mui/material";
import LoadingImage from "../../assets/loading/main.gif";

const ContainerStyled = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
});

const CamvioLoaderUnstyled = ({ className }) => {
  return (
    <ContainerStyled className={className}>
      <img alt="loader" src={LoadingImage} width="300px" />
    </ContainerStyled>
  );
};

const CamvioLoader = styled(CamvioLoaderUnstyled)({});

export default CamvioLoader;
